import ProxyBase from '../../../../../core/proxies/ProxyBase'

class IndustryProxy extends ProxyBase {
  getReportYear(params) {
    return this.get('TopYear', params)
  }
}

export default new IndustryProxy('IndustryOverview/')
